import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Route } from 'src/app/shared/models/route';
import { Vehicle } from 'src/app/shared/models/vehicle';

@Component({
	selector: 'app-vehicule-modal-detail-route',
	templateUrl: './vehicule-modal-detail-route.component.html',
	styleUrls: ['./vehicule-modal-detail-route.component.scss']
})
export class VehiculeModalDetailRouteComponent {
	vehicule: Vehicle;
	route: Route;

	constructor(public bsModalRef: BsModalRef) {}

	// ngOnInit(): void {}
}
